// extracted by mini-css-extract-plugin
module.exports = {"buttons":"PaymentMethodModalV2_buttons__Px9Ay","slide-in-out":"PaymentMethodModalV2_slide-in-out__IabuT","fade-in-out":"PaymentMethodModalV2_fade-in-out__qnxF4"};